export default "__VITE_ASSET__LwVJgeaa__"